import React from 'react'
import { cn } from '../../utils/cn'

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  description?: string
}

export function Checkbox({ className, label, description, children, ...props }: CheckboxProps) {
  const hasLabel = label || description || children
  
  return (
    <div className={cn("flex items-start gap-3", hasLabel ? "flex-row" : "")}>
      <input
        type="checkbox"
        className={cn(
          'h-4 w-4 rounded border-gray-300 text-primary-600',
          'focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          className
        )}
        {...props}
      />
      {hasLabel && (
        <div className="text-sm flex items-center">
          {label && <label className="font-medium text-gray-900 dark:text-white cursor-pointer">{label}</label>}
          {description && <p className="text-dark-text-muted mt-0.5">{description}</p>}
          {children && <label className="font-medium text-gray-900 dark:text-white cursor-pointer">{children}</label>}
        </div>
      )}
    </div>
  )
}